import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@material-ui/core';
import { useSharingDialog } from './SharingDialog';
import { ShareService } from '../../services/ShareService';
import { AssetShareType } from '../../entities/ShareItem';

interface Props {
    isOpen: boolean;
    onClose: () => void;
}

export function RemoveVideoDialog(props:Props){
    const sharingContext = useSharingDialog();
    const { sharedItem } = sharingContext;
    const [disabled, setDisabled] = useState(false);

    const removeVideo = async() => {
        if (!disabled)
            return;

        setDisabled(true);
        const response = await ShareService.saveAssetShare({
            commentsEnabled: sharedItem.commentsEnabled,
            enabled: sharedItem.enabled,
            assetShareId: sharedItem.id,
            assetShareVideoTypeId: AssetShareType.None,
            videoPath: undefined
        });
        setDisabled(false);

        if(response.error) return sharingContext.onError('An unknown error occurred. Please try again.');

        sharingContext.updateSharedItem(response.data);
        sharingContext.showMessage("Video Removed")
    }

    return (
        <Dialog
            open={props.isOpen}
            onClose={props.onClose}
            aria-labelledby="remove-video-dialog-title"
        >
            <DialogTitle id="remove-video-dialog-title">Remove Video</DialogTitle>
            <DialogContent>
                Are you sure you want to remove this video?
                </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose} color="primary">
                    Cancel
                    </Button>
                <Button color="secondary" disabled={disabled} onClick={() => removeVideo()}>
                    Remove
                    </Button>
            </DialogActions>
        </Dialog>
    )
}